import * as React from 'react';
import "./LoadingSpinner.tsx.css"

export interface LogoSpinnerProps{
    color?: string;
}

export const LoadingSpinner = React.forwardRef<SVGSVGElement, LogoSpinnerProps>(
    (
        {
            color = "currentColor",
            ...props
        },
        ref,
    ) => {

        return (
          <div className="loading-animation-wrapper">

            <svg
                ref={ref}
                className={"casa-loading-svg"}
                width="210"
                height="228"
                viewBox="0 0 210 228"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                data-component="logo-spinner"
                {...props}
            >
                <path
                    d="M50 146.311C50 131.274 53.223 128.051 68.2605 128.051H81.6862C96.7237 128.051 99.9467 131.274 99.9467 146.311V159.737C99.9467 174.774 96.7237 177.997 81.6862 177.997H68.2605C53.223 177.997 50 174.774 50 159.737V146.311Z"
                    fill="var(--color-primary)"
                />
                <path
                    d="M50 86.9949C50 71.9574 53.223 68.7344 68.2605 68.7344H81.6862C96.7237 68.7344 99.9467 71.9574 99.9467 86.9949V100.421C99.9467 115.458 96.7237 118.681 81.6862 118.681H68.2605C53.223 118.681 50 115.458 50 100.421V86.9949Z"
                    fill="var(--color-primary)"
                />
                <path
                    d="M109.316 127.581C109.316 112.543 112.539 109.32 127.577 109.32H141.003C156.04 109.32 159.263 112.543 159.263 127.581V141.006C159.263 156.044 156.04 159.267 141.003 159.267H127.577C112.539 159.267 109.316 156.044 109.316 141.006V127.581Z"
                    fill="var(--color-primary)"
                />
                <path
                    d="M109.316 68.2634C109.316 53.2259 112.539 50.0029 127.577 50.0029H141.003C156.04 50.0029 159.263 53.2259 159.263 68.2634V81.6891C159.263 96.7266 156.04 99.9496 141.003 99.9496H127.577C112.539 99.9496 109.316 96.7266 109.316 81.6891V68.2634Z"
                    fill="var(--color-primary)"
                />
                <title>Loading spinner</title>
            </svg>
          </div>
        );
    },
);
